import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SummaryType } from '@common/enums/SummaryType';
import { IChatInteraction } from '@common/models/Chat/IChatInteraction';

@Component({
  selector: 'app-feedback-dialog',
  templateUrl: './feedback-dialog.component.html',
  styleUrls: ['./feedback-dialog.component.scss']
})
export class FeedbackDialogComponent implements OnInit, OnChanges {
  value:string
  selectedSummaryType: SummaryType
  feedbackForm: FormGroup;
  
  constructor(
    private readonly fb: FormBuilder
  ) { }
  
  @Input() showdialog: boolean
  @Input() selectedChatInteraction: IChatInteraction
  @Input() like:boolean;
  @Output() emitUserFeedback: EventEmitter<{comment: string, userStarRating?: number}> = new EventEmitter()
  @Output() closeDialog: EventEmitter<boolean> = new EventEmitter()
  
  ngOnInit(): void {
    this.initializeForm();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['like'] && this.feedbackForm) {
      this.updateValidators();
    }
  }

  initializeForm(): void {
    this.feedbackForm = this.fb.group({
      comment: [''],
      userRating: [null]
    });
    this.updateValidators();
  }

  updateValidators(): void {
    const userRatingControl = this.feedbackForm.get('userRating');
    if (this.like) {
      userRatingControl.clearValidators();
    } else {
      userRatingControl.setValidators([Validators.required]);
    }
    userRatingControl.updateValueAndValidity();
  }

  emitSummary(){
    this.emitUserFeedback.emit({
      comment: this.feedbackForm.get('comment').value,
      userStarRating: this.feedbackForm.get('userRating').value
    })
  }
  
  onClose(){
    this.feedbackForm.reset();
    this.closeDialog.emit(false)
  }

}
